import React, { useEffect, useMemo, useState } from "react";
import { SingleCascaderSelectForCustom } from "app/(new-pages)/components/allSelect/baseSelect/pc/SingleCascaderSelectForCustom";
import { isCustomOption } from "app/(new-pages)/components/allSelect/baseSelect/pc/SingleCascaderSelectForCustom/utils/custom";

import { useSharedData } from "bossjob-remote/dist/hooks";
import { selfJobFunctionOptionsKey } from "app/components/providers/configProvider";

import styles from "./index.module.scss";
import { formatTemplateString } from "helpers/formatter";

const JobFunctionSinglePc = (props: {
  lang: any;
  value: any;
  onChange: (value: any) => void;
  wrapperClassName?: string;
  suffixIcon?: any;
  placeholder?: any;
}) => {
  const { lang = {}, value: outerValue, onChange = () => {}, placeholder, ...reset } = props;
  const profile = lang.profile || {};
  const config = useSharedData("CONFIG");
  const dic = useSharedData("DICTIONARY");
  const jobFunctions = config?.[selfJobFunctionOptionsKey] || [];
  const [value, setValue] = useState([]);

  let opts = useMemo(() => {
    if (!jobFunctions.length) {
      return [];
    }

    const data = jobFunctions
      .filter((e) => e["seo-value"] !== "others")
      .map((v) => {
        return {
          label: v.value,
          value: v.id,
          children: v.sub_function_list.map((v) => {
            return {
              label: v.value,
              value: v.id,
              children: v.job_titles.map((v) => {
                return {
                  ...v,
                  label: v.value,
                  value: v.id
                };
              })
            };
          })
        };
      });
    if (outerValue?.id == 881) {
      data.push({
        ...outerValue,
        value: outerValue.id,
        label: outerValue.value
      });
    }

    return data;
  }, [jobFunctions, outerValue]);

  useEffect(() => {
    let result = {};
    let result1 = {};
    let result2 = {};

    opts.forEach((v) => {
      result[v.value] = v;
      if (v.children) {
        (v.children || []).forEach((v1) => {
          result1[v1.value] = v1;
          v1.p = v;
          (v1.children || []).forEach((v2) => {
            result2[v2.value] = v2;
            v2.p = v1;
          });
        });
      }
    });
    let key = outerValue.id || outerValue.value;
    if (isCustomOption(key)) {
      setValue([key]);
      return;
    }
    if (key && key != 881) {
      let target = result2[key];
      let newResult = [];
      while (target) {
        newResult.push(target.value);
        target = target.p;
      }
      setValue(newResult.reverse() as any);
    } else {
      setValue(outerValue?.id ? [outerValue?.id] : []);
    }
  }, [opts, outerValue]);

  console.log("outerValue", outerValue, value, opts);
  const handleChange = (value, selectedOptions) => {
    if (selectedOptions?.length > 0) {
      const result = selectedOptions[selectedOptions?.length - 1];
      //
      if (result?.id == "custom-881") {
        result.id = 881;
      }

      if (result?.value == "custom-881") {
        result.value = 881;
      }

      onChange(result);
      setValue(value || []);
    } else {
      onChange(null);
      setValue(value || []);
    }
  };

  const emptyString =
    dic?.comm?.cascader?.resultNotFound ||
    "No matches found. {{add}} your custom job title instead.";

  return (
    <>
      <SingleCascaderSelectForCustom
        {...reset}
        value={value}
        onChange={handleChange}
        options={opts}
        placeholder={placeholder || profile?.jobFunctionPlaceholder}
        cascaderStyles={{ maxHeight: 300, overflow: "hidden" }}
        onlySearchInLastedLayer
        searchBoardPlaceholder={lang?.companyDetail?.overview?.Find}
        renderSearchEmpty={(value) => {
          return (
            <div
              className={styles.emptyNode}
              dangerouslySetInnerHTML={{
                __html: formatTemplateString(emptyString, {
                  add: `<span class="${styles.highlightSpan}">${dic?.profile?.add || "Add"}</span>`
                })
              }}
            ></div>
          );
        }}
      />
    </>
  );
};

export default JobFunctionSinglePc;
